import { makeStyles } from 'tss-react/mui';

const name = 'PageWithBillingTabs';

export const usePageWithBillingTabsStyles = makeStyles({ name })(theme => ({
  root: {
    paddingBottom: theme.spacing(15),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8),

    height: 'unset',

    [theme.breakpoints.down('xl')]: {
      gap: theme.spacing(5),
    },

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(7),
    },

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(6),
    },
  },
  suspendedUserAlert: {
    marginBottom: 0,

    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(-2),
    },
  },
}));
